<template>
  <div class="newSeller">
    <v-card class="pa-10" flat>
      <v-card-title class="pa-0">
        {{ $route.name == 'NewSeller' ? '新增主播' : '更新主播' }}
        <v-spacer></v-spacer>
        <div>
          <v-switch label="啟用" disabled v-model="seller.disabled" :true-value="0" :false-value="1"></v-switch>
        </div>
      </v-card-title>
      <v-divider class="mb-5"></v-divider>
      
      <v-row>
        <v-col>
          <v-subheader>身分證號碼</v-subheader>
        </v-col>
        <v-col>
          <v-text-field 
            dense 
            v-model="seller.ID_number"
            :rules="[$rules.notEmpty]"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-subheader>姓</v-subheader>
        </v-col>
        <v-col class="d-flex">
          <v-text-field 
            dense 
            v-model="seller.last_name"
            :rules="[$rules.notEmpty]"
          ></v-text-field>
          <v-subheader>名</v-subheader>
          <v-text-field 
            dense 
            v-model="seller.first_name"
            :rules="[$rules.notEmpty]"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-subheader>出生日期</v-subheader>
        </v-col>
        <v-col>
          <v-menu
            v-model="datePicker"
            :close-on-content-click="false"
            transition="scale-transition"
            bottom
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="seller.birthday"
                :rules="[$rules.notEmpty]"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="seller.birthday"
              :active-picker.sync="activePicker"
              :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
               @change="datePicker = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-subheader>手機號碼</v-subheader>
        </v-col>
        <v-col>
          <v-text-field 
            dense 
            v-model="seller.tel"
            :rules="[$rules.integer]"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="d-flex">
          <v-subheader>密碼</v-subheader>
          <v-tooltip bottom nudge-right="120">
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="ml-2" v-bind="attrs" v-on="on">fa-question-circle</v-icon>
            </template>
            <span>密碼長度須為 6 到 15 個字元，且包含英文字母及數字</span>
          </v-tooltip>
        </v-col>
        <v-col class="d-flex align-end">
          <v-text-field 
            dense 
            type="password"
            v-model="seller.password"
            :rules="[$rules.password]"
            :disabled="!edit_password && updating"
          ></v-text-field>
          <v-checkbox
            v-if="updating" 
            class="ml-4"
            v-model="edit_password"
          ></v-checkbox>
        </v-col>
      </v-row>
      
      <v-row>
        <v-col>
          <v-subheader>Email</v-subheader>
        </v-col>
        <v-col>
          <v-text-field 
            dense 
            v-model="seller.email"
            :rules="[$rules.email]"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-subheader>暱稱</v-subheader>
        </v-col>
        <v-col>
          <v-text-field 
            dense 
            v-model="seller.nickname"
            :rules="[$rules.notEmpty]"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-subheader>三圍</v-subheader>
        </v-col>
        <v-col>
          <v-text-field 
            dense
            v-model="seller.measurements"
            placeholder="B/W/H" 
            :rules="[$rules.measurements]"
          >
          </v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-subheader>罩杯</v-subheader>
        </v-col>
        <v-col>
          <v-text-field 
            dense
            v-model="seller.cup"
            :rules="[$rules.cup]"
          >
          </v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-subheader>年齡</v-subheader>
        </v-col>
        <v-col>
          <v-text-field 
            dense 
            v-model="seller.age"
            :rules="[$rules.integer]"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-subheader>身高(cm)</v-subheader>
        </v-col>
        <v-col>
          <v-text-field 
            dense 
            v-model="seller.height"
            :rules="[$rules.float]"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-subheader>體重(kg)</v-subheader>
        </v-col>
        <v-col>
          <v-text-field  dense  v-model="seller.weight" :rules="[$rules.float]"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-subheader>興趣</v-subheader>
        </v-col>
        <v-col>
          <v-text-field dense v-model="seller.interest" :rules="[$rules.notEmpty]"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-subheader>居住城市</v-subheader>
        </v-col>
        <v-col>
          <v-text-field dense v-model="seller.city" :rules="[$rules.notEmpty]"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-subheader>Telegram</v-subheader>
        </v-col>
        <v-col>
          <v-text-field dense v-model="seller.telegram"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-subheader>Line</v-subheader>
        </v-col>
        <v-col>
          <v-text-field dense v-model="seller.line"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-subheader>職業</v-subheader>
        </v-col>
        <v-col>
          <v-select
            v-model="seller.job"
            dense
            placeholder="選擇職業"
            :items="seller_job_types"
            item-text="name"
            item-value="num"
          ></v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-subheader>主播抽成</v-subheader>
        </v-col>
        <v-col>
          <!-- <v-select
            v-model="seller.personal_commission"
            dense
            placeholder="選擇抽成"
            :items="commissionList"
            item-text="text"
            item-value="value"
          ></v-select> -->
          <div class="d-flex">
            <v-text-field 
              dense 
              v-model="seller.personal_commission"
              :rules="[$rules.integer]"
            ></v-text-field>
            %
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-subheader>優先度(↑)</v-subheader>
        </v-col>
        <v-col>
          <v-text-field dense v-model="seller.priority" :rules="[$rules.integer]"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-subheader>自我介紹</v-subheader>
        </v-col>
        <v-col>
          <v-textarea 
            dense 
            outlined 
            v-model="seller.self_intro" 
            :rules="[$rules.notEmpty]" 
            hide-details
          ></v-textarea>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-subheader>銀行名稱</v-subheader>
        </v-col>
        <v-col>
          <v-text-field dense v-model="seller.bank" :rules="[$rules.notEmpty]"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-subheader>銀行分行</v-subheader>
        </v-col>
        <v-col>
          <v-text-field dense v-model="seller.bank_branch" :rules="[$rules.notEmpty]"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-subheader>銀行帳號</v-subheader>
        </v-col>
        <v-col>
          <v-text-field dense v-model="seller.account_number" :rules="[$rules.integer]"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-subheader>桌布</v-subheader>
        </v-col>
        <v-col class="d-flex flex-wrap">
          <div 
            class="file-input mr-4" 
            @click="$refs[`wallpaper`].click()"
          >
            <v-icon class="delete" v-if="seller.wallpaper" @click.stop="seller.wallpaper = ''">
              fa-times-circle
            </v-icon>
            <div class="uploadText" v-if="!seller.wallpaper">
              <v-icon>fa-plus</v-icon>
              Select File
            </div>
            <input 
              type="file" 
              ref="wallpaper"
              :accept="$accept_file_type.image"
              v-if="!seller.wallpaper" 
              onclick="this.value = null" 
              @change="uploadImage('wallpaper')"
            /> 
            <v-img v-if="seller.wallpaper" :src="seller.wallpaper.startsWith('data:') ? seller.wallpaper : $HOST_URL + seller.wallpaper"/>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-subheader>頭像</v-subheader>
        </v-col>
        <v-col class="d-flex flex-wrap">
          <div 
            class="file-input" 
            @click="$refs[`usericon`].click()"
          >
            <v-icon class="delete" v-if="seller.usericon" @click.stop="seller.usericon = ''">
              fa-times-circle
            </v-icon>
            <div class="uploadText" v-if="!seller.usericon">
              <v-icon>fa-plus</v-icon>
              Select File
            </div>
            <input 
              type="file" 
              ref="usericon" 
              :accept="$accept_file_type.image"
              v-if="!seller.usericon" 
              onclick="this.value = null" 
              @change="uploadImage('usericon')"
            /> 
            <v-img v-if="seller.usericon" :src="seller.usericon.startsWith('data:') ? seller.usericon : $HOST_URL + seller.usericon"/>
          </div>
        </v-col>
      </v-row>

      <v-row class="mt-6">
        <v-btn block dark color="indigo" @click="submit">送出</v-btn>
      </v-row>

    </v-card>
  </div>    
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  data() {
    return {
      edit_password: false,
      jobs: [],
      commissionList: [
        {text: '60%', value: 0.6},
        {text: '50%', value: 0.5},
        {text: '40%', value: 0.4},
      ],
      datePicker: false,
      activePicker: null,
      seller: {
        ID_number: '',
        password: '',
        email: '',
        nickname: '',
        last_name: '',
        first_name: '',
        birthday: '',
        wallpaper: '',
        usericon: '',
        bust: '',
        waist: '',
        hips: '',
        cup: '',
        age: '',
        height: '',
        weight: '',
        interest: '',
        city: '',
        job: '',
        priority: 0,
        self_intro: '',
        tel: '',
        line: '',
        instagram: '',
        telegram: '',
        remark: '',        group_commission: 0.5,
        personal_commission: '',
        account_number: '',
        bank: '',
        bank_branch: '',
        disabled: false
      }
    }
  },
  created() {
    if(this.updating) {
      this.getSeller()
    }
  },
  computed: {
    ...mapState('global', ['seller_job_types']),
    updating() {
      return this.$route.name == 'EditSeller'
    },
    formIsValid() {
      return (
        this.$rules.notEmpty(this.seller.ID_number) &&
        this.$rules.notEmpty(this.seller.last_name) &&
        this.$rules.notEmpty(this.seller.first_name) &&
        this.$rules.notEmpty(this.seller.birthday) &&
        (this.updating ? true : this.$rules.password(this.seller.password)) &&
        this.$rules.notEmpty(this.seller.nickname) &&
        this.$rules.email(this.seller.email) &&
        this.$rules.integer(this.seller.tel) &&
        this.$rules.measurements(this.seller.measurements) &&
        this.$rules.cup(this.seller.cup) &&
        this.$rules.integer(this.seller.age) &&
        this.$rules.float(this.seller.height) &&
        this.$rules.float(this.seller.weight) &&
        this.$rules.notEmpty(this.seller.interest) &&
        this.$rules.notEmpty(this.seller.city) &&
        this.$rules.integer(this.seller.job) &&
        this.$rules.float(this.seller.personal_commission) &&
        this.$rules.integer(this.seller.priority) &&
        this.$rules.notEmpty(this.seller.self_intro) &&
        this.$rules.notEmpty(this.seller.bank) &&
        this.$rules.notEmpty(this.seller.bank_branch) &&
        this.$rules.notEmpty(this.seller.usericon)
      )
    },
  },
  watch: {
    datePicker(val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    },
  },
  methods: {
    async uploadImage(data) {
      let image = event.target.files[0]
      if(!await this.$func.fileValidation(image)) {
        return
      }
      this.seller[data] = await this.$func.fileToBase64(image)
      this.$forceUpdate()
    },
    getSeller() {
      this.axios.get(`/admin/seller/${this.$route.params.id}`).then(response => {
        this.seller = response.data
        this.seller.measurements = `${this.seller.bust}/${this.seller.waist}/${this.seller.hips}`
        this.seller.priority = this.seller.seller_priority
        this.seller.personal_commission = parseInt(this.seller.personal_commission * 100)
        this.seller.password = null
      })
    },
    submit() {
      if(!this.formIsValid) {
        return
      }
      this.seller.bust = this.seller.measurements.split('/')[0]
      this.seller.waist = this.seller.measurements.split('/')[1]
      this.seller.hips = this.seller.measurements.split('/')[2]
      this.seller.personal_commission /= 100
      if(this.updating) {
        this.seller.usericon = this.seller.usericon.startsWith('data:') ? this.seller.usericon : null
        this.seller.wallpaper = this.seller.wallpaper.startsWith('data:') ? this.seller.wallpaper : null
        this.seller.password = this.seller.password && this.edit_password ? this.seller.password : null
        this.axios.put(`/admin/seller/${this.seller.id}`, this.seller).then(response => {
          this.$root.$emit('alert', 'success', '更新成功')
          this.$router.push('/admin/seller')
        }).catch(() => {
          this.$root.$emit('alert', 'error', '更新失敗')
          this.seller.personal_commission *= 100
        })
      }
      else {
        this.axios.post(`/admin/seller`, this.seller).then(response => {
          this.$root.$emit('alert', 'success', '新增成功')
          this.$router.push('/admin/seller')
        }).catch(() => {
          this.$root.$emit('alert', 'error', '新增失敗')
          this.seller.personal_commission *= 100
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.newSeller {
  .row {
    align-items: center;
    & > div:first-child {
      flex-grow: 0;
      min-width: 140px;
    }
    & > div:nth-child(2) {
      max-width: 800px;
    }
  }
  .v-subheader {
    white-space: nowrap;
  }
  i {
    color: unset !important;
  }
}
</style>